module.exports = __webpack_public_path__ + "img/meguru02.47730b03.png";